export const Permissions = {
  DesignViewOwn: 'design.view.own',
  DesignEditOwn: 'design.edit.own',
  DesignViewGroup: 'design.view.group',
  DesignViewAll: 'design.view.all',
  DesignEditAll: 'design.edit.all',
  UserViewGroup: 'user.view.group',
  UserEditGroup: 'user.edit.group',
  UserViewAll: 'user.view.all',
  UserEditAll: 'user.edit.all',
  PrinterViewAll: 'printer.view.all',
  PrinterEditAll: 'printer.edit.all',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];

export function hasPermission(
  user: { permissions?: string[] } | null | undefined,
  permission: string
): boolean {
  return user?.permissions?.includes(permission) === true;
}

export function canEditDesign(
  user: { id: number; permissions?: string[] } | null | undefined,
  ownerId?: number | null
): boolean {
  if (!user) return false;
  if (hasPermission(user, Permissions.DesignEditAll)) return true;
  if (hasPermission(user, Permissions.DesignEditOwn) && ownerId === user.id) return true;
  if ((user.permissions == null || user.permissions.length === 0) && ownerId === user.id) return true;
  return false;
}

export function canUseDevelopmentUi(
  user: { group?: { IsDev?: boolean } | null } | null | undefined,
  isExhibition: boolean
): boolean {
  return user?.group?.IsDev === true || isExhibition;
}

export function canUseDevelopmentExports(
  user: { group?: { IsDev?: boolean } | null } | null | undefined
): boolean {
  return user?.group?.IsDev === true;
}
